import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'

export const TextHeaderEs = () => {
    return (
        <HighlightedText
            text="ELIGE TUS BOLETOS Y CONSIGUE UN BONO"
            highlights={[
                { word: 'Y' },
                { word: 'CONSIGUE' },
                { word: 'UN' },
                { word: 'BONO' },
            ]}
            breakAfterWords={['BOLETOS']}
            className={styles.text_header}
        />
    )
}
